(function (process,global,Buffer,__argument0,__argument1,__argument2,__argument3,__filename,__dirname){
require('./components/importer')
var vueImporter = new Vue({
    el:'#vueImporter',
    data: {
        heading: "Admin Importer"
    }
});

}).call(this,require("rH1JPG"),typeof self !== "undefined" ? self : typeof window !== "undefined" ? window : {},require("buffer").Buffer,arguments[3],arguments[4],arguments[5],arguments[6],"/vue/admin-importer.js","/vue")